import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';

import { CLASSIFICATION_CATDICT } from '@/api/domains/classifications.types';
import { CustomFormLabel } from '@/components/form-controls';
import { RHFClassificationField } from '@/components/form-controls/RHFClassificationField';
import { CLASSIFICATION_CATEGORY_DICT_NODE_ID } from '@/shared/constants/classification.constants';

export const CategoryDictionaryField = () => {
  const { t } = useTranslation('nomenclature-page');

  return (
    <FormControl fullWidth>
      <CustomFormLabel htmlFor="categoryDictionary">
        {t('modals.form.ui.expert-data.category-dictionary')}
      </CustomFormLabel>
      <RHFClassificationField
        fullWidth
        parentId={CLASSIFICATION_CATEGORY_DICT_NODE_ID}
        name="categoryDictionary"
        id="categoryDictionary"
        variant="filled"
        isParentSelectable={false}
        shouldShowSelectedValueDescription={false}
        alias={CLASSIFICATION_CATDICT}
      />
    </FormControl>
  );
};
